import styled from 'styled-components';

import defaultCover from '@/features/journey/admin/assets/defaultCover.png';
import { Button } from '@/ui/Button';
import { Skeleton } from '@/ui/Skeleton';
import { makeNamespacedComponent } from '@/ui/utils';

const ImageContainerStyled = styled.div`
  border-radius: 8px;
  height: 280px;
  width: 100%;
  position: relative;
`;

const ImageStyled = styled.img`
  border-radius: 8px;
  height: 280px;
  width: 100%;
  object-fit: cover;
  opacity: 80%;
  z-index: 1;
`;

const OverlayStyled = styled.div`
  top: 0;
  border-radius: 8px;
  position: absolute;
  height: 100%;
  width: 100%;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.4) 100%);
  z-index: 2;
`;

const RootStyled = styled.div`
  position: relative;
  height: 280px;
  background: ${({ theme }) => theme.tones.neutral[0]};
  border-radius: 8px;
`;

const EditButtonStyled = styled(Button)`
  position: absolute;
  right: 16px;
  top: 16px;
  z-index: 3;
`;

const TitlesContainerStyled = styled.div`
  position: absolute;
  z-index: 3;
  left: 40px;
  top: 50%;
  transform: translateY(-50%);
  max-width: 80%;
`;

const TitleStyled = styled.div`
  ${({ theme }) => theme.typography.title1};
  color: ${({ theme }) => theme.tones.neutral[100]};
  max-height: 132px;
  overflow: hidden;
`;

const SubtitleStyled = styled.div`
  ${({ theme }) => theme.typography.title4};
  color: ${({ theme }) => theme.tones.neutral[100]};
  text-transform: uppercase;
  margin-bottom: 10px;
`;

const ActionsContainerStyled = styled.div`
  position: absolute;
  z-index: 3;
  top: 16px;
  right: 16px;
`;

type JourneyEditHeroProps = {
  subtitle?: string;
  actions?: JSX.Element;
  onEdit?: () => void;
  title: string;
  imageUrl?: string;
  withOverlay?: boolean;
};

const JourneyEditHero = ({ onEdit, title, subtitle, imageUrl, actions, withOverlay }: JourneyEditHeroProps): JSX.Element => {
  return (
    <RootStyled>
      <ImageContainerStyled>
        <ImageStyled src={imageUrl || defaultCover} />
        {withOverlay && <OverlayStyled />}
      </ImageContainerStyled>
      {actions ? (
        <ActionsContainerStyled>{actions}</ActionsContainerStyled>
      ) : (
        <EditButtonStyled variant="neutral" onClick={onEdit}>
          Edit
        </EditButtonStyled>
      )}
      <TitlesContainerStyled>
        {!!subtitle && <SubtitleStyled>{subtitle}</SubtitleStyled>}
        <TitleStyled>{title}</TitleStyled>
      </TitlesContainerStyled>
    </RootStyled>
  );
};

const LoadingState = () => <Skeleton height={280} />;

const _Hero = makeNamespacedComponent(JourneyEditHero, {
  LoadingState,
});

export { _Hero as JourneyEditHero };
